module.exports = __webpack_public_path__ + "static/media/088-send.3d16ef27.svg";